import { render, staticRenderFns } from "./KampusMerdeka.vue?vue&type=template&id=4a7079f2&scoped=true"
import script from "./KampusMerdeka.vue?vue&type=script&lang=js"
export * from "./KampusMerdeka.vue?vue&type=script&lang=js"
import style0 from "./KampusMerdeka.vue?vue&type=style&index=0&id=4a7079f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7079f2",
  null
  
)

export default component.exports